import { AnyStepData, StepHandle } from '@spiffcommerce/core'
import { createContext, useContext, useState } from 'react'

type AppContextType = {
  isLengthScene: boolean
  isPendantQuantityScene: boolean
  isPendantScene: boolean
  isLastScene: boolean
  onBodyPreviewStep: StepHandle<AnyStepData> | null
  isOnBodyPreview: boolean
  availablePreLoadedPendants: string[]
  setIsLengthScene: React.Dispatch<React.SetStateAction<boolean>>
  setIsPendantQuantityScene: React.Dispatch<React.SetStateAction<boolean>>
  setIsPendantScene: React.Dispatch<React.SetStateAction<boolean>>
  setIsLastScene: React.Dispatch<React.SetStateAction<boolean>>
  setOnBodyPreviewStep: React.Dispatch<React.SetStateAction<StepHandle<AnyStepData> | null>>
  setIsOnBodyPreview: React.Dispatch<React.SetStateAction<boolean>>
  setAvailablePreLoadedPendants: React.Dispatch<React.SetStateAction<string[]>>
}

const initialState: AppContextType = {
  isLengthScene: false,
  isPendantQuantityScene: false,
  isPendantScene: false,
  isLastScene: false,
  onBodyPreviewStep: null,
  isOnBodyPreview: false,
  availablePreLoadedPendants: [],
  setIsLengthScene: () => {},
  setIsPendantQuantityScene: () => {},
  setIsPendantScene: () => {},
  setIsLastScene: () => {},
  setOnBodyPreviewStep: () => {},
  setIsOnBodyPreview: () => {},
  setAvailablePreLoadedPendants: () => {}
}

export const AppContext = createContext(initialState)
export const useAppContext = () => useContext(AppContext)

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLengthScene, setIsLengthScene] = useState(true)
  const [isPendantQuantityScene, setIsPendantQuantityScene] = useState(false)
  const [isPendantScene, setIsPendantScene] = useState(false)
  const [isLastScene, setIsLastScene] = useState(false)
  const [onBodyPreviewStep, setOnBodyPreviewStep] = useState<StepHandle<AnyStepData> | null>(null)
  const [isOnBodyPreview, setIsOnBodyPreview] = useState(false)
  const [availablePreLoadedPendants, setAvailablePreLoadedPendants] = useState<string[]>([])

  const state = {
    isLengthScene,
    isPendantQuantityScene,
    isPendantScene,
    isLastScene,
    onBodyPreviewStep,
    isOnBodyPreview,
    availablePreLoadedPendants,
    setIsLengthScene,
    setIsPendantQuantityScene,
    setIsPendantScene,
    setIsLastScene,
    setOnBodyPreviewStep,
    setIsOnBodyPreview,
    setAvailablePreLoadedPendants
  }

  return <AppContext.Provider value={state}>{children}</AppContext.Provider>
}
